export default __webpack_public_path__ + "static/wyn-8be0cf6b3811ef5b0258572c117acf79.svg";